import React from "react";
import { InlineEditField } from "../../../../../common/form";

export default function InputCondition({field, value, updateRuleField, condition}) {
  function formatCurrency(value) {
    if (!value) return "$0.00";
    const number = parseFloat(value.replace(/[^0-9.]/g, ""));
    if (isNaN(number)) return "$0.00";
    return number.toLocaleString("en-US", { style: "currency", currency: "USD" });
  }

  function handleSave(updateValue) {
    updateRuleField(field, updateValue)
  }

  if(condition) {
    return (
      <InlineEditField
        value={value}
        onSave={handleSave}
        renderEdit={({value, onChange, autoFocus}) => (
          <input
            type="number"
            step={"0.01"}
            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-teal-600 sm:text-sm/6"
            value={value}
            onChange={e => onChange(e.target.value)}
          />
        )}
      />
    )
  } else {
    return null;
  }

}
